module.exports = __webpack_public_path__ + "assets/img/tianjin.54e2f3e8.png";